<template>
  <div id="app" class="container">   
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {}
  },
  methods: {

  },
  mounted() {
    document.addEventListener('touchstart',function (event) {
        if(event.touches.length > 1){
            event.preventDefault();
        }
    });
    let lastTouchEnd=0;
    document.addEventListener('touchend',function (event) {
        var now = (new Date()).getTime();
        if(now - lastTouchEnd <= 300){
            event.preventDefault();
        }
        lastTouchEnd = now;
    },false);
    document.addEventListener('gesturestart', function (event) {
        event.preventDefault();
    });
  }
};
</script>

<style lang="scss">
    *{
        // overflow: scroll;
        -webkit-overflow-scrolling: touch;
    }
</style>


